<template>
    <div>
    <Head :title="`Editar gasto: ${form.name}`" />
    <div class="flex items-center justify-between mb-8">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/spents">Gastos</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
      <Link
        class="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
        href="/spent-categories"
      >
        <svg class="-ml-0.5 mr-1.5 h-4 w-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
        </svg>
        Gestionar Categorías
      </Link>
    </div>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.date" :error="form.errors.date" class="pb-8 pr-6 w-full lg:w-1/2" type="date" label="Fecha" />
            <text-input v-model="form.amount" :error="form.errors.amount" class="pb-8 pr-6 w-full lg:w-1/2" label="Monto" />
            <select-input v-model="form.spent_category_id" :error="form.errors.spent_category_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Categoria">
                <option value="">Seleccionar</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">
                    {{category.name}}
                </option>
            </select-input>
            <select-input v-model="form.method" :error="form.errors.method" class="pb-8 pr-6 w-full lg:w-1/2" label="Método">
                <option value="">Seleccionar</option>
                <option value="efectivo">Efectivo</option>
                <option value="transferencia">Transferencia</option>
                <option value="pago-movil">Pago Movil</option>
                <option value="zelle">Zelle</option>
            </select-input>
          </div>
          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar gasto</button>
            <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Actualizar gasto</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import TrashedMessage from '@/Shared/TrashedMessage'
  
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      TextInput,
      SelectInput
    },
    layout: Layout,
    props: {
      spent: Object,
      categories: Object
    },
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          name: this.spent?.name,
          amount: this.spent.amount,
          date: this.spent?.date,
          method: this.spent?.method,
          spent_category_id: this.spent.spent_category_id
        }),
      }
    },
    methods: {
      update() {
        this.form.put(`/spents/${this.spent.id}`)
      },
      destroy() {
        if (confirm('Estas seguro que quieres eliminar esta gastos?')) {
          this.$inertia.delete(`/spents/${this.spent.id}`)
        }
      },
    },
  }
  </script>
  